import React from 'react';

import IconReports from '@/assets/icon-reports.svg?react';
import { permissions } from '@/constants';
import PlantIcon from '@/comp/common/icons/PlantIcon';
import ValueIcon from '@/comp/common/icons/ValueIcon';
import EngineIcon from '@/comp/common/icons/EngineIcon';
import SettingsIcon from '@/comp/common/icons/SettingsIcon';

import { NavItemDetails } from '../StationPage.utils';
import ServiceIcon from '@/comp/common/icons/ServiceIcon';
import LifecycleIcon from '@/comp/common/icons/LifecycleIcon';
import ReportIcon from '@/comp/common/icons/ReportIcon';
import AISparkleIcon from '@/comp/common/icons/AISparkleIcon';
import { StationTier } from '@/constants/enums';

export const getTitle = (pathname: string, navItems: NavItemDetails[]) =>
  navItems.find(item => pathname.includes(item.link))?.label;

export const getNavItems = (t: (key: string) => string, stationTier?: StationTier): NavItemDetails[] => {
  const items: NavItemDetails[] = [
    {
      icon: <PlantIcon className="icon" />,
      label: t('PLANT'),
      link: 'tab',
    },
    {
      icon: <ValueIcon className="icon" />,
      label: t('VALUE'),
      link: 'value',
      permissions: permissions.VIEW_STATION_VALUE_DASHBOARD,
    },
    {
      icon: <IconReports className="icon" />,
      label: t('REPORTS'),
      link: 'reports',
      permissions: permissions.VIEW_STATION_REPORTS,
    },
    {
      icon: <EngineIcon className="icon" />,
      label: t('ENGINE'),
      link: 'engine',
      permissions: permissions.VIEW_STATION_ENGINE,
    },
    {
      icon: <ServiceIcon className="icon" />,
      label: t('Installer'),
      link: 'installer',
      permissions: permissions.ACCESS_INSTALLATION_VALIDATION_VIEW,
    },
    {
      icon: <LifecycleIcon className="icon" />,
      label: t('Lifecycle'),
      link: 'lifecycle',
      permissions: permissions.VIEW_STATION_STAGE_LIFECYCLE,
    },
    {
      icon: <AISparkleIcon className="icon-ai" />,
      label: t('Assistant'),
      link: 'ai-assistant',
      permissions: permissions.VIEW_SALES_ASSISTANT,
    },
    {
      icon: <SettingsIcon className="icon" />,
      label: t('SETTINGS'),
      link: 'settings',
    },
  ];

  // Add Report tab if station tier is not Monitor (same logic as desktop SideMenu)
  if (stationTier !== StationTier.Monitor) {
    // Insert before Settings (second to last position)
    items.splice(items.length - 1, 0, {
      icon: <ReportIcon className="icon" />,
      label: t('Report'),
      link: 'report-tab',
      permissions: permissions.VIEW_PERIODIC_REPORTS,
    });
  }

  return items;
};
